import axios from "axios";

// const serverApi = "http://localhost:5002/api";
// const serverApi = "https://imed.serveis.in/api";
const getServerApi = () => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const protocol = isLocalhost ? 'http' : 'https';
  // Use same domain as frontend when in production (serves both API and static files)
  return isLocalhost ? "http://localhost:5002/api" : `${protocol}://${hostname}/api`;
};


export const getRoomExists = async (roomId) => {
  const response = await axios.get(`${getServerApi()}/room-exists/${roomId}`);
  return response.data;
};

export const getTURNCredentials = async () => {
  const response = await axios.get(`${getServerApi()}/get-turn-credentials`);
  return response.data;
};

export const uploadFile = async (roomId, file) => {
  const formData = new FormData();
  formData.append("roomId", roomId);
  formData.append("file", file); // 'file' should be the actual file object
  console.log(`${getServerApi()}/upload`, formData);
  const response = await axios.post(`${getServerApi()}/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

